import _ from 'lodash';

import {
    FETCH_ORDERS,
    FETCH_ORDERS_FAIL,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDER,
    FETCH_ORDER_SUCCESS
} from '../actions/Order';

const INITIAL_STATE = {
    orders: {},
    isLoading: false
}

export default function (state = INITIAL_STATE, action) {
    let newOrders = {};
    switch (action.type) {
        case FETCH_ORDERS:
            return { ...state, isLoading: true };
        case FETCH_ORDERS_SUCCESS:
            newOrders = _.merge(state.orders, action.payload);
            return { ...state, isLoading: false, orders: newOrders };
        case FETCH_ORDERS_FAIL:
            return { ...state, isLoading: false };
        case FETCH_ORDER:
            return { ...state, isLoading: true };
        case FETCH_ORDER_SUCCESS:
            newOrders = _.merge(state.orders, action.payload);
            return { ...state, isLoading: false, orders: newOrders }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/OrderReducer.js